import React, { useState } from 'react'
import FilterRDSPALNOW from '../components/FilterRDSPALNOW.jsx'
import WaterLevel from '../components/Chart/WaterLevel.jsx';
import WaterLevelSkeleton from '../components/Chart/WaterLevelSkeleton.jsx';


const RealTime = ({ onDataToleransi }) => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    return (
        <div className="flex flex-col items-center justify-center w-full rounded gap-4 bg-white p-4">
            {/* <h2 className="text-2xl">REALTIME</h2> */}

            <FilterRDSPALNOW onData={(values) => setData(values)} onDataToleransi={onDataToleransi} onLoading={(values) => setLoading(values)} />
            {loading ? (
                <div className="flex flex-col md:flex-row justify-evenly items-center gap-6 w-full">
                    <WaterLevelSkeleton />
                    <WaterLevelSkeleton />
                </div>
            ) : (
                <div className="flex flex-col md:flex-row justify-evenly items-center gap-6 w-full">
                    <WaterLevel dataSource={data.BBM_IN} title="Filling" />
                    <WaterLevel dataSource={data.BBM_OUT} title="Consumption" />
                </div>
            )}
        </div >
    )
}

export default RealTime